export const REFERRAL_STORAGE_KEY = "referralCode";
export const REFERRAL_REDEMPTION_STATUS_KEY = "referralRedeemed";
